var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event",class:{
        'event_local': _vm.isLocal === true,
        'event_holiday': _vm.isHoliday === true
    }})}
var staticRenderFns = []

export { render, staticRenderFns }